import EA from 'helpers/init';

// Add method to <video> element, add your video path to "data-src", leave empty src (src="")
export default EA.Methods.videoLazyLoad = ($this) => {
    const videoEl = $this;
    let loaded = false;

    function playVideo(should) {
        if (should) {
            videoEl.play();
        } else {
            videoEl.pause();
        }
    }

    function handleIntersect(entries, observer) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const dataSrc = videoEl.dataset.src;
                if (dataSrc !== '') {
                    videoEl.addEventListener('progress', (e)=> {
                        if (!loaded) {
                            playVideo(entry.isIntersecting);
                            loaded = true;
                        }
                    });
                    videoEl.addEventListener('loadeddata', (e)=> {
                        if (!loaded) {
                            playVideo(entry.isIntersecting);
                            loaded = true;
                        }
                    });

                    videoEl.src = dataSrc;
                    videoEl.dataset.src = '';
                }
                else {
                    playVideo(entry.isIntersecting);
                }
            }
            else {
                playVideo(entry.isIntersecting);
            }
            // console.log(entry.isIntersecting);
        });
    }

    function createObserver() {
        const options = {
            root: null,
            rootMargin: '100px',
            threshold: 0,
        };

        const observer = new IntersectionObserver(handleIntersect, options);
        observer.observe(videoEl);
    }

    createObserver();
};
